export const $refreshTokenService = {
  _promise: null,
  _resolve: null,
  isInProgress() {
    return this._promise !== null;
  },
  start() {
    this._promise = new Promise(resolve => {
      this._resolve = resolve;
    });
  },
  finish() {
    if (this._resolve) this._resolve();
    this._promise = null;
    this._resolve = null;
  },
  awaitRefresh() {
    return this._promise || Promise.resolve();
  }
};
